export const UPDATE_EXPLORER_LOADER = 'UPDATE_EXPLORER_LOADER'
export const UPDATE_OUTPUT = 'UPDATE_OUTPUT'
export const UPDATE_ALL_CONTACTS = 'UPDATE_ALL_CONTACTS'
export const UPDATE_LAST_SESSION = 'UPDATE_LAST_SESSION'
export const UPDATE_NETWORK_VIEW_PARAMS = 'UPDATE_NETWORK_VIEW_PARAMS'
export const UPDATE_NETWORK_VIEW_URL = 'UPDATE_NETWORK_VIEW_URL'
export const UPDATE_ALL_NODES = 'UPDATE_ALL_NODES'
export const UPDATE_ALL_EDGES = 'UPDATE_ALL_EDGES'
export const UPDATE_VIEW_NODE = 'UPDATE_VIEW_NODE'
export const UPDATE_NETWORK = 'UPDATE_NETWORK'
export const UPDATE_SINGLE_NODE = 'UPDATE_SINGLE_NODE'
export const UPDATE_CUSTOMER_LAYER = 'UPDATE_CUSTOMER_LAYER'
export const UPDATE_NETWORK_BREADCRUMB = 'UPDATE_NETWORK_BREADCRUMB'
export const UPDATE_EXPLORER_FILTER_DATA = 'UPDATE_EXPLORER_FILTER_DATA'
export const UPDATE_NETWORK_BREADCRUMB_DATA = 'UPDATE_NETWORK_BREADCRUMB_DATA'
export const UPDATE_NETWORK_FILTER = 'UPDATE_NETWORK_FILTER'
export const UPDATE_NO_RESULT_DATA = 'UPDATE_NO_RESULT_DATA'
export const UPDATE_NO_RESULT_MODAL = 'UPDATE_NO_RESULT_MODAL'
export const UPDATE_RETAILERS = 'UPDATE_RETAILERS'
export const UPDATE_PRODUCT_MODAL = 'UPDATE_PRODUCT_MODAL'
export const UPDATE_PRODUCT_DATA = 'UPDATE_PRODUCT_DATA'
export const UPDATE_CUSTOMER_MODAL = 'UPDATE_CUSTOMER_MODAL'
export const UPDATE_CUSTOMER_DATA = 'UPDATE_CUSTOMER_DATA'
export const UPDATE_CUSTOMER_EDGES = 'UPDATE_CUSTOMER_EDGES'
export const UPDATE_METADATA_OPEN = 'UPDATE_METADATA_OPEN'
export const UPDATE_METADATA_DATA = 'UPDATE_METADATA_DATA'
export const UPDATE_RESULT_MESSAGE = 'UPDATE_RESULT_MESSAGE'
export const UPDATE_RESULT_MODAL = 'UPDATE_RESULT_MODAL'
export const UPDATE_EXPLORER_PAGINATION = 'UPDATE_EXPLORER_PAGINATION'
export const UPDATE_NODES_INFO = 'UPDATE_NODES_INFO'
export const UPDATE_EDGES_INFO = 'UPDATE_EDGES_INFO'
export const EXPAND_CUSTOMER_NODES = 'EXPAND_CUSTOMER_NODES'
export const LIST_CUSTOMER_DETAILS = 'LIST_CUSTOMER_DETAILS'
export const EXPAND_CONTACT_NODES = 'EXPAND_CONTACT_NODES'
export const LIST_CONTACT_DETAILS = 'LIST_CONTACT_DETAILS'
export const DISCONNECT_NODES = 'DISCONNECT_NODES'
export const EXPAND_RECURSIVELY = 'EXPAND_RECURSIVELY'
export const UPDATE_TOTAL_NETWORK_VALUE = 'UPDATE_TOTAL_NETWORK_VALUE'
